import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'
import Toggle from '../dataClass/Toggle'
import address from './modules/address'
import homeStore from './modules/homeStore'
import couponDetail from './modules/couponDetail'
import {
  apiActions
} from '../api'
// import actInfo from '../assets/datas/actInfo'

Vue.use(Vuex)
const debug = process.env.VUE_APP_BUILD_TYPE !== 'production'

const state = {
  version: '4.12.0.0', // 每次发版需更改版本号，传递至登录页
  urlParams: GetUrlParams(location.href),
  api: { // clientTicket
    onSdkReady: {
      toggle: new Toggle(),
      data: null
    },
    initWxShare: {
      toggle: new Toggle(),
      data: null
    }
  },
  connectTokenFail: false,
  sdk: {}, // openid  accessToken lat lng isApp,
  scrollPosition: {},
  dialogVisible: {
    detail: false,
    share: false
  },
  actInfo: {
    id: 1
  },
  browser: {
    versions: (function () {
      var u = navigator.userAgent
      // var app = navigator.appVersion
      return { // 移动终端浏览器版本信息
        IE: u.indexOf('MSIE') > -1, // IE内核
        presto: u.indexOf('Presto') > -1, // opera内核
        webKit: u.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
        gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1, // 火狐内核
        mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
        android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, // android终端或uc浏览器
        iPhone: u.indexOf('iPhone') > -1, // 是否为iPhone或者QQHD浏览器
        iPad: u.indexOf('iPad') > -1, // 是否iPad
        webApp: u.indexOf('Safari') === -1, // 是否web应该程序，没有头部与底部
        weChat: !!u.match(/MicroMessenger/i), // 是否微信
        aliPay: !!u.match(/Alipay/i) // 是否支付宝
      }
    }()),
    language: (navigator.browserLanguage || navigator.language).toLowerCase()
  },
  actTittle: '',
  cartNum: 0,
  totalFee: '',
  userInfo: {},
  serviceInfo: {}, // {serviceId, developType, templeteName, templeteStatus}
  isXfsh: false, // 是否为小富市集
  clientId: '', // 小富市集的
  rfServiceId: '', // 小富市集的
  communityId: '', // 小富市集的
  communityName: '',
  cityId: [],
  cityName: [],
  cartList: [],
  communityInfo: {},
  trolley: [],
  productList: [],
  storeInfo: {
    templeteName: 'STORE',
    share: {
      title: '',
      desc: '',
      icon: '',
      link: '',
      descTimeline: ''
    },
    fulinBussinessStatus: 0,
    nannyBussinessStatus: 0
  },
  instantBuyNum: 1, // 立即购买字段
  instantBuyGoodObj: {}, // 立即购买字段

  confirmOrderInfo: {
    userName: '',
    mobile: '',
    addrDetail: '',
    remark: '',
    communityId: sessionStorage.getItem('communityId'),
    mutiTotal: '',
    mutiOrderCreateParamListJson: ''
  },
  confirmOrderParams: {}, // 确认订单api入参对象
  confirmOrderDetail: [], // 确认订单页面详细信息对象
  couponListObj: {}, // 优惠券列表

  quickCouponList: [], // 闪付店铺优惠券列表
  quickCouponObj: {}, // 闪付订单选定优惠券对象
  cost: '', // 闪付金额
  noCouponCost: 0, // 闪付总价减满减优惠后，不使用优惠券

  showLeftBottomBtn: true, // 隐藏左下角浮动按钮--订单列表--购物车
  showHomeBottomBar: true // 隐藏首页底部浮动栏
}
for (let i in apiActions) {
  let obj = {
    toggle: new Toggle(),
    data: null
  }
  Object.assign(state.api, {
    [i]: obj
  })
}
export default new Vuex.Store({
  state,
  actions,
  getters,
  mutations,
  modules: {
    address,
    homeStore,
    couponDetail
  },
  plugins: debug ? [
    createLogger({
      collapsed: true,
      logger: console
    })
  ] : []
})
/**
 * 获取search参数
 * @param {*} url
 * http://aa.com/?ccc=789&ddd=012#/hash1/hash2?aaa=123&bbb=456 =>  {ccc: "789", ddd: "012", aaa: "123", bbb: "456"}
 */
function GetUrlParams (url) {
  // console.log('ULR',url)
  const pattern = /(\w+)=((\w|\.|-|%)+)/ig
  const parames = {}
  url.replace(pattern, function (str, key, value) {
    parames[key] = value
  })
  return parames
}
